export default __webpack_public_path__ + "static/media/23.73e9181e.jpg";